class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Enables or disables Automatic Location Updates feature for the
     * specified common phones.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/devices/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async post(assignMultipleDevicesAutomaticLocationUpdates, restRequestConfig) {
        const r = await this.rc.post(this.path(), assignMultipleDevicesAutomaticLocationUpdates, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
